import React from 'react';
import config from '../../../../config';
import LKModal from '../../../components/Modal/Modal';
import { connect } from 'react-redux';

function UploadedPrescription(props) {
  const { dataLocale, showPrescription, showUploadPrescModal, prescriptionView } = props;
  const { POWER_PRESCRIPTION } = dataLocale;
  // const showUploadPrescModal = useCallback(() => {
  //     showUploadedPresc(!showPrescription);
  // }, [showPrescription]);
  return (
    <>
      {showPrescription && (
        <LKModal
          keyboard
          dialogClassName="myOrder-showUploadedPower"
          hideHandler={showUploadPrescModal}
          showModal={showPrescription}
          size="lg"
        >
          <div className="display-flex" style={{ flexDirection: 'column', width: '100%' }}>
            <button
              aria-label="Close Modal Icon"
              className="close"
              type="button"
              onClick={showUploadPrescModal}
            >
              ×
            </button>
            <div className="fs20 fw500 margin-b15">{POWER_PRESCRIPTION}</div>
            <img
              alt={dataLocale.UPLOAD_IMG_ALT}
              src={`${config.apiPath?.downloadUploadedPrescription}${prescriptionView?.filename}`}
              style={{ maxWidth: '50%' }}
            />
          </div>
        </LKModal>
      )}
    </>
  );
}

const mapStateToProps = state => {
  return {
    dataLocale: state.locale,
  };
};

export default connect(mapStateToProps, null)(UploadedPrescription);
